export default __webpack_public_path__ + "static/media/template.cb700769.svg";